<div class="row">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'INTEGRATION.CREATE_PRICE_LIST' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm" routerLink="/export/integrations/kaspi">
                        <i class="bi bi-backspace"></i> {{ 'BACK_TO_LIST' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="addOffer()">
                        <i class="bi bi-plus-circle"></i> {{ 'INTEGRATION.ADD_ELEM' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()" [disabled]="form.invalid">
                        <i class="bi bi-save"></i> {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                    <div class="col-12">

                        <div formArrayName="offers">

                            <div *ngFor="let offer of form.get('offers')['controls']; let i = index;">

                                <div class="row" [formGroupName]="i" class="row offer-item">

                                    <div class="col-3">
                                        <div class="form-group">
                                            <label for="product_id_{{i}}"><span class="star">*</span> {{ 'PRODUCT.PRODUCTS_LIST' | translate }}</label>
                                            <ng-select  
                                                id="product_id_{{i}}"
                                                class="custom" 
                                                clearAllText="{{ 'CLEAR' | translate }}"
                                                notFoundText="{{ 'NO_DATA' | translate }}"
                                                bindLabel="name"
                                                bindValue="id"
                                                formControlName="product_id"
                                                [loading]="loading"
                                                [items]="products"
                                                (search)="getProducts($event.term)"
                                                (change)="getProducts()">
                                            </ng-select>
                                            <div *ngIf="errorMessages">
                                                <div *ngFor="let item of errorMessages.product_id">
                                                    <div class="text-error" *ngIf="validation(['offers', i, 'product_id'], item.type)">
                                                        {{ item.message | translate: item.options }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-3">
                                        <div class="form-group">
                                            <label for="price_{{i}}" class="label"><span
                                                    class="star">*</span>{{ 'PRICE,PRICE' | translate }}</label>
                                            <input type="text" class="form-control" id="price_{{i}}"
                                                formControlName="price" mask="separator">
                                        </div>
                                    </div>

                                    <div class="col-5">

                                        <div class="row">
                                            <div class="col-12">
                                                <label class="label"><span class="star">*</span> {{ 'INTEGRATION.AVAILABILITY' | translate }}</label>
                                            </div>

                                            <div class="col-1">
                                                <button type="button" class="btn btn-primary btn-sm"
                                                    (click)="addAvailability(i)">
                                                    <i class="bi bi-plus-circle"></i>
                                                </button>
                                            </div>

                                            <div class="col-11 availabilities-box">
                                                <ul class="availabilities-list" formArrayName="availabilities">
                                                    <li class="availabilities-item"
                                                        *ngFor="let availability of offer.get('availabilities')['controls']; let j = index;">
                                                        <div class="availabilities-tag" [formGroupName]="j">
                                                            {{ availability.get('storeId').value }}: <span
                                                                *ngIf="availability.get('available').value == 'yes'">
                                                                {{ 'YES' | translate }}</span>
                                                            <div class="availabilities-tag-btn-remove"
                                                                (click)="removeAvailability(i, j)"
                                                                *ngIf="j > 0 && (j+1) == offer.get('availabilities').value.length">
                                                                <i class="bi bi-x-circle"></i>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-1 offer-btn-box">
                                        <button *ngIf="form.get('offers').value.length > (i+1)" type="button"
                                            class="btn btn-danger btn-sm" (click)="removeOffer(i)">
                                            <i class="bi bi-x-circle"></i> {{ 'DELETE' | translate }}
                                        </button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </form>

            </div>

        </div>

    </div>
</div>